import React, { Component } from 'react';
import './index.scss';
import Loader from '../../pages/loader';
import * as API from '../../configuration/apiconfig';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import { keyboardLayout } from '../../utils/keyBoardLayout';

const buttonTheme = [
  {
    class: 'phone-login-close-button',
    buttons: '{phoneLoginCloseButton}',
  },
  {
    class: 'backspace-button',
    buttons: '{bksp}',
  },
];

export default class PhoneNumberLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      layoutName: 'ip',
      loginErrorMsg: '',
      phoneNumber: '',
      showKeyboard: false,
    };
  }

  // keyBoardOnChangePhone = input => {
  //   alert('1');
  //   if (this.props.activeInput === 'phone') {
  //     this.setState({ phoneNumber: input });
  //   }
  // };

  keyBoardOnKeyPress = button => {
    // console.log("Button pressed", button);
    if (button === '{shift}' || button === '{lock}') this.keyBoardHandleShift();

    if (button === '{phoneLoginCloseButton}') {
      this.setState({
        showKeyboard: false,
        phoneNumber: '',
        loginErrorMsg: '',
      });
      this.props.phoneNumberChange('');
    }
  };

  keyBoardHandleShift = () => {
    const layoutName = this.state.layoutName;
    this.setState({
      layoutName: layoutName === 'default' ? 'shift' : 'default',
    });
  };

  clickKeyboardIconPhone = () => {
    this.setState(
      {
        showKeyboard: !this.state.showKeyboard ? true : false,
      },
      () => {
        var getInputElem = document.getElementById('phoneNumberInput');
        if (getInputElem) {
          document.getElementById('phoneNumberInput').focus();
        }
      }
    );
  };

  setKeyboard = () => {
    this.setState({
      showKeyboard: true,
    });
  };

  openKeyboard = () => {
    this.setState({ showKeyboard: true });
  };

  closeKeyboard = () => {
    this.setState({ showKeyboard: false });
  };

  phoneNumberChange = phoneNumber => {
    this.props.phoneNumberChange(phoneNumber);
  };

  render() {
    return (
      <React.Fragment>
        <Loader loader={this.state.loader} />
        <div className={`phone-number-login ${this.props.dynamicComponent ? 'dynamic-component-login' : ''}`}>
          <div className="content">
            <div className="manual-scanner-sec">
              <div className="form-blk">
                <div className="fm-inner">
                  <div className="input-wrap">
                    <input
                      onFocus={() => {
                        this.props.setLoginType('phone');
                        this.props.toggleKeyboard('phone');
                      }}
                      ref={input => {
                        this.textInput = input;
                      }}
                      id="phoneNumberInput"
                      type="text"
                      placeholder="Enter Mobile Number"
                      autoComplete="off"
                      value={this.props.phoneNumber}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
            {this.props.phoneNumber != '' && this.props.loginErrorMsg != '' && (
              <div className="error-blk">
                <p>{this.props.loginErrorMsg}</p>
              </div>
            )}
          </div>
        </div>
        {this.state.showKeyboard ? (
          <Keyboard
            keyboardRef={r => (this.keyboard = r)}
            layoutName={this.props.activeKeyboard == 'phone' ? 'ip' : 'shift'}
            onChange={input => this.phoneNumberChange(input)}
            onKeyPress={this.keyBoardOnKeyPress}
            layout={keyboardLayout}
            display={{
              '{bksp}': 'Backspace',
              '{phoneLoginCloseButton}': 'Close',
            }}
            disableRowButtonContainers={true}
            baseClass={'login-barcodescan-keyboard'}
            maxLength={10}
            buttonTheme={buttonTheme}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
